function setTitle(title) {
    document.title = `${title} - Forms Collections - NHS England`;
}

function scrollToTopOfPage() {
    window.scrollTo(0, 0);
}

export { scrollToTopOfPage, setTitle };
